'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (endpoint, data) {
  var onScheduleFailure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var blob = new Blob([JSON.stringify(data)], { type: 'text/plain' });
  var didSchedule = navigator.sendBeacon(endpoint, blob);

  /*
  * From w3 beacon spec -
  *
  * The user agent imposes limits on the amount of data that can be sent via this API:
  * this helps ensure that such requests are delivered successfully and with minimal impact
  * on other user and browser activity. If the amount of data to be queued exceeds the user agent limit,
  * this method returns false; a return value of true implies the browser has queued the data for transfer.
  * However, since the actual data transfer happens asynchronously,
  * this method does not provide any information whether the data transfer has succeeded or not.
  */
  if (!didSchedule && typeof onScheduleFailure === 'function') {
    onScheduleFailure();
  }

  return didSchedule;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker/static-1.108/js/helpers/sendBeacon.js
// module id = 412
// module chunks = 0